<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'nome'"
            v-model="formulario.nome"
            :placeholder="'Nome do Provedor'"
            data-vv-as="Nome do Provedor"
            v-validate="'required|max:255'"
            :error="validationErrors.first('nome')"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'responsavel'"
            v-model="formulario.responsavel"
            :placeholder="'Responsável'"
            data-vv-as="Responsável"
            v-validate="'required|max:255'"
            :error="validationErrors.first('responsavel')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="email"
            :name="'email_responsavel'"
            v-model="formulario.email_responsavel"
            :placeholder="'E-mail do Responsável'"
            data-vv-as="E-mail"
            v-validate="'required|email|max:255'"
            :error="validationErrors.first('email_responsavel')"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'telefone_responsavel'"
            v-model="formulario.telefone_responsavel"
            :placeholder="'Telefone do Responsável'"
            data-vv-as="Telefone"
            v-validate="'required|max:20'"
            :error="validationErrors.first('telefone_responsavel')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'regional'"
            v-model="formulario.regional"
            :placeholder="'Regional'"
            data-vv-as="Regional"
            v-validate="'required|max:100'"
            :error="validationErrors.first('regional')"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'uf'"
            v-model="formulario.uf"
            :placeholder="'UF'"
            data-vv-as="UF"
            v-validate="'required|max:2'"
            :error="validationErrors.first('uf')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'cm'"
            v-model="formulario.cm"
            :placeholder="'CM (Cidade / Município)'"
            data-vv-as="CM"
            v-validate="'required|max:100'"
            :error="validationErrors.first('cm')"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'cluster'"
            v-model="formulario.cluster"
            :placeholder="'Cluster'"
            data-vv-as="Cluster"
            v-validate="'required|max:100'"
            :error="validationErrors.first('cluster')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'grupo_operadora'"
            v-model="formulario.grupo_operadora"
            :placeholder="'Grupo operadora'"
            data-vv-as="Grupo operadora"
            v-validate="'max:255'"
            :error="validationErrors.first('grupo_operadora')"
          />
        </div>
      </div>

      <div v-if="ehModuloRecuperacao" class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormToggleComponent
            name="recebe_integracao"
            titulo="Recebe integração"
            :value="formulario.recebe_integracao"
            @input="formulario.recebe_integracao = Boolean($event)"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CTRL_MODULOS } from '@/common/boot/Constantes'

function valorRecebeIntegracao (provedor) {
  return provedor?.recebe_integracao !== false
}

function criarFormulario (provedor = {}, incluirIntegracao = false) {
  const formulario = {
    id: provedor.id || null,
    nome: provedor.nome || '',
    responsavel: provedor.responsavel || '',
    email_responsavel: provedor.email_responsavel || '',
    telefone_responsavel: provedor.telefone_responsavel || '',
    regional: provedor.regional || '',
    uf: provedor.uf || '',
    cm: provedor.cm || '',
    cluster: provedor.cluster || '',
    grupo_operadora: provedor.grupo_operadora || ''
  }

  if (incluirIntegracao) {
    formulario.recebe_integracao = valorRecebeIntegracao(provedor)
  }

  return formulario
}

export default {
  name: 'FormularioCtrlProvedoresComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    provedor: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formulario: criarFormulario(
        this.provedor,
        this.$store.getters['ctrlModulos/moduloAtivo'] == CTRL_MODULOS.RECUPERACAO
      )
    }
  },

  computed: {
    ...mapGetters('ctrlModulos', ['moduloAtivo']),

    ehModuloRecuperacao () {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    }
  },

  methods: {
    ...mapActions('ctrlProvedores', ['salvarProvedor', 'atualizarProvedor']),

    payloadFormulario () {
      const payload = { ...this.formulario }

      if (!this.ehModuloRecuperacao) {
        delete payload.recebe_integracao
        return payload
      }

      payload.recebe_integracao = Boolean(payload.recebe_integracao)
      return payload
    },

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      const payload = this.payloadFormulario()

      if (this.tipoFormulario === 'salvar') {
        await this.salvarProvedor(payload)
      } else {
        await this.atualizarProvedor(payload)
      }

      this.limparCampos()
      this.fecharModal()
    },

    limparCampos () {
      this.formulario = criarFormulario({}, this.ehModuloRecuperacao)
      this.$validator.reset()
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
